export default __webpack_public_path__ + "static/media/attractions1.c23bd55f.avif";